import React from 'react';
import { MiniLogo, StudioHeader } from '@vp/diy-editor-ui';
import { FlexBox, SkeletonText, SkeletonTextLine } from '@vp/swan';
import { bookendData } from 'src/utils/bookendData';
import { text } from 'src/utils/localizationUtil';
import './vistaLogo.css';

const skeletonStyle = {
  borderRadius: { borderRadius: 8 },
  helpLink: { width: 155, height: 16 },
  specs: { width: 208, height: 16, marginLeft: 24 },
};

export const HeaderLeadingSkeleton = () => (
  <MiniLogo
    className={'mini-logo'}
    logo={bookendData.base.logo}
    href={bookendData.base.homeUrl}
    accessibleText={text('miniLogo')}
  />
);

export const HeaderTrailingSkeleton = () => (
  <FlexBox flexDirection="row">
    <SkeletonText style={skeletonStyle.helpLink}>
      <SkeletonTextLine style={skeletonStyle.borderRadius}></SkeletonTextLine>
    </SkeletonText>
    <SkeletonText style={skeletonStyle.specs}>
      <SkeletonTextLine style={skeletonStyle.borderRadius}></SkeletonTextLine>
    </SkeletonText>
  </FlexBox>
);

export const HeaderTrailingMobileSkeleton = () => (
  <SkeletonText>
    <SkeletonTextLine width="narrow"></SkeletonTextLine>
  </SkeletonText>
);

export const HeaderLogoMobileSkeleton = () => (
  <>
    <MiniLogo
      className={'mini-logo-mobile'}
      logo={bookendData.base.inlineSecondaryLogo}
      href={bookendData.base.homeUrl}
      accessibleText={text('miniLogo')}
    />
    <SkeletonText>
      <SkeletonTextLine width="narrow"></SkeletonTextLine>
    </SkeletonText>
  </>
);

// Full skeleton header (original component) retained for initial data loading state
export const HeaderSkeleton = () => (
  <StudioHeader
    px={{ xs: 5, sm: 6 }}
    py={{ xs: 3, sm: 5 }}
    leadingNode={<HeaderLeadingSkeleton />}
    trailingNode={<HeaderTrailingSkeleton />}
    leadingNodeSmallScreen={<></>}
    trailingNodeSmallScreen={<HeaderTrailingMobileSkeleton />}
    logoSmallScreen={<HeaderLogoMobileSkeleton />}
    className={'header-style'}
  />
);
